import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const searchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchProperties: builder.query({
      query: (query) => ({
        url: API_PREFIX + "/property/search",
        method: "POST",
        body: {
          region: query.region,
          city: query.city,
          check_in: query.check_in,
          check_out: query.check_out,
          guests: query.guests,
        },
      }),
      providesTags: ["SearchResults"],
      invalidatesTags: ["SearchResults"],
    }),
    filterProperties: builder.query({
      query: (filter) => ({
        url: API_PREFIX + `/property/filter/`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["SearchResults"],
    }),
    getByCity: builder.query({
      query: (filter) => ({
        url: API_PREFIX + `/property/byCity/`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["SearchResults"],
    }),
  }),
});

export const {
  useSearchPropertiesQuery,
  useLazySearchPropertiesQuery,
  useLazyFilterPropertiesQuery,
  useLazyGetByCityQuery,
} = searchApiSlice;
